import { defineNuxtRouteMiddleware, navigateTo } from '#app'

export default defineNuxtRouteMiddleware((to) => {
  if (to.path.includes('//')) {
    return navigateTo({ path: to.path.replace('//', '/') })
  }
})
